<template>
    <div class="project-team-page">
        <!--   BANNER图   -->
        <!--        <img class="banner-image" />-->
        <div v-if="imgUrl" class="banner-image">
            <img :src="imgUrl.picurl" alt="">
        </div>

        <div class="entity-wrap">
            <!--    服务标签    -->
            <div class="service-tags-content">
                <div class="tags-title">厂家直控层层把关省心、可靠</div>
                <!--      标签内容      -->
                <div class="tags-content">
                    <div v-for="tag in arrServiceTags" :key="tag.name" class="tags-item">
                        <img class="tag-icon" :src="require('@/assets/images/user/house/project-team-finish-icon.png')" alt="" />
                        <p class="tag-text">{{ tag.name }}</p>
                    </div>
                </div>
            </div>
            <div class="banner-image">
                <img v-lazy="require('@/assets/images/project-detail/0005-test.png')" alt="">
            </div>
            <!--    人员    -->
            <template v-if="dataList.length > 0">
                <div v-for="(item, index) in dataList" :key="index" class="person-item-content">
                    <div class="person-top">
                        <div class="person-infi-left">
                            <div class="head-img">
                                <img v-lazy="item.icon" class="head-image" />
                            </div>
                            <div class="info">
                                <div style="display: flex;align-items: center;">
                                    <div class="name">{{ item.name }}</div>
                                    <div class="jobNumber">{{ item.job_number }}</div>
                                </div>
                                <!-- <div class="start">
                                    <img :src="require('@/assets/images/team/start-active.png')" class="head-image" v-for="item in item.score_rang" :key="item" />
                                    <span>{{ item.score_rang }}分</span>
                                </div> -->
                            </div>
                        </div>
                        <div class="person-infi-right">
                            <a :href="'tel:' + item.phone">
                                <img :src="require('@/assets/images/team/working_icon.png')" class="head-image" />
                            </a>
                        </div>
                        <!-- 身份 -->
                        <div class="card">{{ item.rel_group_name }}</div>
                    </div>
                    <div v-if="item.certification.length > 0" class="person-bottom">
                        <div v-for="(item1, index1) in item.certification" :key="index1" class="per-img">
                            <img :src="item1.icon" alt="">
                            <span>{{ item1.name }}</span>
                        </div>
                    </div>
                </div>
            </template>

            <!--        头像        -->
        </div>
    </div>
</template>

<script>
import { Image } from "vant";

export default {
    name: "project-team",
    components: {
        VantImage: Image,
    },
    data() {
        return {
            // 标签渲染数组
            arrServiceTags: [
                {
                    name: "上门设计",
                },
                {
                    name: "专属定制",
                },
                {
                    name: "一站式售后",
                },
                {
                    name: "三维实景方案",
                },
                {
                    name: "施工全流程在线交付",
                },
                {
                    name: "实时在线监管",
                },
            ],
            dataList: [], // 负责人列表
            imgUrl: {},
        };
    },
    created() {
        $init(() => {
            this.$store.commit("loadSkeleton", { bool: true, type: "team" }); // 页面loading开启
            let that = this;
            const { new_srv_projectmgnid } =
                that.$userHouse.state.usreHouserList.project;
            Promise.all([
                that.$store.dispatch("banner/getData", 9),
                that.$userHouse.dispatch("getTeamData", {
                    projectmgnid: new_srv_projectmgnid,
                }),
            ]).then((res) => {
                let objData = that.$userHouse.state.userTeamObj;
                for (let i in objData) {
                    if (objData[i].length != 0) {
                        that.dataList.push({ i, ...objData[i] });
                    }
                }
                that.imgUrl = that.$store.state.banner.team;
                that.$store.commit("loadSkeleton", {
                    bool: false,
                    type: "team",
                }); // 页面loading开启
            });
        });
    },
    computed: {
        setTile() {
            return function (value) {
                if (value == "project_manager") return "项目经理";
                if (value == "project_supervisor") return "监理";
                if (value == "project_salesperson") return "签单手";
                if (value == "project_designer") return "设计者";
                if (value == "project_responsible_person") return "施工人员";
            };
        },
    },
};
</script>

<style scoped lang="scss">
.project-team-page {
    min-height: 100vh;
    background: $defaultBackgroundGary;

    .banner-image {
        width: 100%;
        // height: 366px;
        background: #ededed;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 32px;
        color: #222222;
    }

    .entity-wrap {
        padding: 28px 24px 18px;

        .service-tags-content {
            height: 314px;
            padding: 24px 24px 36px;
            border-radius: $commonRadius;
            margin-bottom: 24px;
            background: #ffffff;

            .tags-title {
                color: $deepGreen;
                font-size: $bigSize;
                display: flex;
                align-items: center;
                line-height: 44px;
                margin-bottom: 18px;
                font-weight: 500;

                &::before {
                    content: "";
                    margin-right: 12px;
                    display: block;
                    width: 6px;
                    height: 32px;
                    background: $defaultGreen;
                }
            }

            .tags-content {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                padding-left: 16px;

                .tags-item {
                    flex: 0 0 40%;
                    margin-top: 24px;
                    display: flex;
                    align-items: center;
                    height: 40px;
                    line-height: 40px;

                    &:nth-child(odd) {
                        flex: 0 0 60%;
                    }

                    .tag-icon {
                        width: 36px;
                        height: 36px;
                        margin-right: 12px;
                    }

                    .tag-text {
                        font-size: $baseSize;
                    }
                }
            }
        }

        .person-item-content {
            margin-top: 32px;
            width: 100%;
            .person-top {
                width: 100%;
                height: 172px;
                background: linear-gradient(135deg, #61ba79 0%, #328444 100%);
                box-shadow: 0px 0px 12px 0px rgba(50, 132, 68, 0.16);
                border-radius: 12px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 36px 0 28px;
                position: relative;
                .person-infi-left {
                    display: flex;
                    align-items: center;
                    .head-img {
                        img {
                            width: 88px;
                            height: 88px;
                            border-radius: 50%;
                        }
                    }
                    .info {
                        padding-left: 20px;
                        .name {
                            font-size: 32px;
                            font-weight: 500;
                            color: #ffffff;
                        }
                        .jobNumber {
                            font-size: 28px;
                            color: #DBECDF;
                            font-weight: 400;
                            margin-left: 20px;
                        }
                        .start {
                            margin-top: 10px;
                            display: flex;
                            align-items: center;
                            img {
                                width: 28px;
                                height: 28px;
                                vertical-align: middle;
                            }
                            span {
                                font-size: 24px;
                                font-weight: 400;
                                color: #ffcb03;
                                padding-left: 16px;
                            }
                        }
                    }
                }
                .person-infi-right {
                    margin-top: 24px;
                    img {
                        width: 76px;
                        height: 76px;
                    }
                }
                .card {
                    width: 148px;
                    height: 48px;
                    background: url(~@/assets/images/team/title_bg.png)
                        no-repeat center/cover;
                    position: absolute;
                    top: 0;
                    right: 0;
                    font-weight: 400;
                    color: #ffffff;
                    text-align: center;
                    line-height: 48px;
                    letter-spacing: 2px;
                }
            }
            .person-bottom {
                background: #ffff;
                padding: 20px 26px;
                display: flex;
                flex-wrap: wrap;
                .per-img {
                    display: flex;
                    align-items: center;
                    margin-bottom: 36px;
                    img {
                        width: 68px;
                        height: 68px;
                        margin-right: 20px;
                    }
                    span {
                        font-size: 32px;
                        font-weight: 400;
                        color: #444444;

                        margin-right: 40px;
                    }
                }
                // div:nth-child(2n - 1){
                //     border: 1px solid red;
                // }
            }
        }
    }
}
</style>
